import React from 'react';
import { ComponentFrame } from "../../frame/ComponentFrame";
import { SectionHeader } from "../section-header/SectionHeader";
import { ItemGroup } from "../item-group/ItemGroup";
import { ListLayout } from "../layout/ListLayout";
import {Variant} from "../item/Variant";
import { Container } from 'reactstrap';
import { Row, Col } from 'reactstrap';
import {Spinner} from "../spinner/Spinner";
import {BasicAnimation} from "../animations/BasicAnimation";

export class VariantList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      variants: this.props.data,
      full: false
    };

    this.toggleFullWidthVariants = this.toggleFullWidthVariants.bind(this);
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      variants: nextProps.data
    });
  }

  toggleFullWidthVariants(){
    this.setState({full: !this.state.full});
  }

  render(){
    return (
      <div className={"variant-list-container"}>
        <BasicAnimation duration={400} delay={0}>
        <ComponentFrame tag="section"
                        header={
                          <SectionHeader align="center"
                                         color="transparent"
                                         title={ "Variants" }
                                         className="less-padding"
                          />
                        }>
          <div>
            <Container className={"p-0"}>
              <Variant header/>
              <Row className="variant-legend-row">
                <Col xs="8" lg="2">Product Code</Col>
                <Col xs="4" lg="1">Intensity</Col>
                <Col xs="4" lg="1">ICAO</Col>
                <Col xs="4" lg="1">FAA</Col>
                <Col xs="4" lg="2">Voltage</Col>
                <Col xs="4" lg="1">Color</Col>
                <Col xs="4" lg="1">Light</Col>
                <Col xs="4" lg="3">Options</Col>
              </Row>
              {
                this.props.loading &&
                <div className="variant-row variant-item variant-loading-row">
                  <Spinner opts={{ radius: 10, lines: 10, length: 2, corners: 1, width: 4 }}/>
                </div>
              }
            </Container>
            {
              ( this.state.variants && this.state.variants.length > 0 && !this.props.loading ) &&
              <ItemGroup layout={ListLayout}
                         layoutAttributes={{noGutters: true}}
                         item={Variant}
                         itemStyle="variant-item" data={this.state.variants}
                         full={this.state.full}/>
            }
          </div>
        </ComponentFrame>
        </BasicAnimation>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/variant-list/VariantList.js